import api from '../config/axios';

export const assignManager = (studentId, managerId, notes) =>
  api.post(`/assignments/${studentId}/manager`, { managerId, notes });
export const assignAssociate = (studentId, associateId, notes) =>
  api.post(`/assignments/${studentId}/associate`, { associateId, notes });
export const assignBanker = (studentId, bankerId, notes) =>
  api.post(`/assignments/${studentId}/banker`, { bankerId, notes });
export const removeManager = (studentId, userId) =>
  api.delete(`/assignments/${studentId}/manager/${userId}`);
export const removeAssociate = (studentId, userId) =>
  api.delete(`/assignments/${studentId}/associate/${userId}`);
export const removeBanker = (studentId, userId) =>
  api.delete(`/assignments/${studentId}/banker/${userId}`);
export const getAssignmentHistory = (studentId) =>
  api.get(`/assignments/${studentId}/history`);
